export default __webpack_public_path__ + "static/media/nonotification_img.f9af5373.png";